export default {
  codigo: 'Código',
  numero_os: 'Nº da OS',
  tabela: {
    codigo: 'Código',
    numero_os: 'Nº da OS',
  },
  titulo_modal: 'Orçamentos',
};
